// Translations for Swedish and English
export const translations = {
  sv: {
    nav: {
      home: "Hem",
      programs: "Program",
      about: "Om oss",
      quran: "Koranen",
      materials: "Material",
      contact: "Kontakt",
      book: "Boka lektion"
    },
    hero: {
      title: "Lär dig recitera Koranen korrekt",
      titleHighlight: "med personlig vägledning online",
      subtitle: "Strukturerade 1-till-1-lektioner, små gruppklasser och en exklusiv medlemsplattform.",
      cta: "Boka gratis provlektion",
      ctaSecondary: "Se program"
    },
    whyUs: {
      title: "Varför välja oss",
      subtitle: "Vi erbjuder en professionell och strukturerad väg till korrekt koranläsning",
      features: [
        {
          title: "Certifierad och erfaren lärare",
          description: "Kvalificerad undervisning med ijazah och mångårig erfarenhet"
        },
        {
          title: "Personlig utvecklingsplan",
          description: "Anpassad studieplan baserad på din nivå och dina mål"
        },
        {
          title: "Fokus på Tajweed",
          description: "Korrekt uttal och recitation enligt traditionella regler"
        },
        {
          title: "Strukturerat lärande",
          description: "Disciplinerad och metodisk undervisning för bästa resultat"
        },
        {
          title: "För barn och vuxna",
          description: "Anpassade program för alla åldrar och nivåer"
        }
      ]
    },
    programs: {
      title: "Våra paket",
      subtitle: "Välj det paket som passar dig bäst. Ju fler lektioner, desto bättre pris!",
      lessonInfo: "40 min per lektion | Max 2-3 elever per klass",
      categories: {
        nooraniyah: "Quran Online Method",
        tajweed: "Tajweed",
        family: "Familjepaket"
      },
      nooraniyah: {
        label: "Quran Online Method - Grundkurs",
        description: "Lär dig läsa Koranen från grunden med korrekt uttal",
        basePrice: "125 kr/lektion",
        packages: [
          {
            name: "Bas",
            lessons: "4 lektioner/månad",
            frequency: "1 lektion per vecka",
            price: "500",
            perLesson: "125 kr/lektion",
            discount: null,
            features: ["Personlig studieplan", "Direkt korrigering av uttal", "Flexibelt schema", "Online via Teams, Zoom eller Google Meet"],
            cta: "Välj Bas",
            popular: false
          },
          {
            name: "Standard",
            lessons: "8 lektioner/månad",
            frequency: "2 lektioner per vecka",
            price: "880",
            perLesson: "110 kr/lektion",
            discount: "Spara 12%",
            features: ["Allt i Bas-paketet", "Snabbare framsteg", "Prioriterad bokning", "Personlig uppföljning"],
            cta: "Välj Standard",
            popular: true
          },
          {
            name: "Premium",
            lessons: "12 lektioner/månad",
            frequency: "3 lektioner per vecka",
            price: "1 200",
            perLesson: "100 kr/lektion",
            discount: "Spara 20%",
            features: ["Allt i Standard-paketet", "Bästa priset per lektion", "Extra övningsmaterial", "Snabbast resultat"],
            cta: "Välj Premium",
            popular: false
          }
        ]
      },
      tajweed: {
        label: "Tajweed - Fördjupning",
        description: "Förfina din koranrecitation med avancerade Tajweed-regler",
        basePrice: "135 kr/lektion",
        packages: [
          {
            name: "Bas",
            lessons: "4 lektioner/månad",
            frequency: "1 lektion per vecka",
            price: "540",
            perLesson: "135 kr/lektion",
            discount: null,
            features: ["Avancerad Tajweed-undervisning", "Artikulationspunkter", "Flexibelt schema", "Online via Teams, Zoom eller Google Meet"],
            cta: "Välj Bas",
            popular: false
          },
          {
            name: "Standard",
            lessons: "8 lektioner/månad",
            frequency: "2 lektioner per vecka",
            price: "960",
            perLesson: "120 kr/lektion",
            discount: "Spara 11%",
            features: ["Allt i Bas-paketet", "Snabbare framsteg", "Prioriterad bokning", "Personlig uppföljning"],
            cta: "Välj Standard",
            popular: true
          },
          {
            name: "Premium",
            lessons: "12 lektioner/månad",
            frequency: "3 lektioner per vecka",
            price: "1 300",
            perLesson: "108 kr/lektion",
            discount: "Spara 20%",
            features: ["Allt i Standard-paketet", "Bästa priset per lektion", "Idzhaam, Ikhfaa & Madd-regler", "Snabbast resultat"],
            cta: "Välj Premium",
            popular: false
          }
        ]
      },
      family: {
        label: "Familjepaket",
        description: "Rabatterade paket för familjer med flera elever",
        basePrice: "Från 100 kr/lektion",
        packages: [
          {
            name: "Familj Duo",
            lessons: "8 lektioner/månad",
            frequency: "4 lektioner per elev/vecka (2 elever)",
            price: "900",
            perLesson: "112 kr/lektion",
            discount: "Spara 10%",
            features: ["2 familjemedlemmar", "4 lektioner per elev/månad", "Anpassad plan per elev", "Flexibel schemaläggning"],
            cta: "Välj Familj Duo",
            popular: false
          },
          {
            name: "Familj Standard",
            lessons: "16 lektioner/månad",
            frequency: "8 lektioner per elev (2 elever)",
            price: "1 600",
            perLesson: "100 kr/lektion",
            discount: "Spara 20%",
            features: ["2 familjemedlemmar", "8 lektioner per elev/månad", "Snabbare framsteg", "Personlig uppföljning"],
            cta: "Välj Familj Standard",
            popular: true
          },
          {
            name: "Familj Premium",
            lessons: "12+ lektioner/månad",
            frequency: "4 lektioner per elev (3+ elever)",
            price: "1 200",
            perLesson: "100 kr/lektion",
            discount: "Spara 20%",
            features: ["3 eller fler familjemedlemmar", "4 lektioner per elev/månad", "Bästa familjepriset", "Gemensam familjerapport"],
            cta: "Välj Familj Premium",
            popular: false
          }
        ]
      }
    },
    about: {
      title: "Om läraren",
      subtitle: "Dedikerad koranundervisning med passion",
      bio: "Med 5 års erfarenhet av koranundervisning erbjuder jag en strukturerad och disciplinerad väg till korrekt koranläsning. Min passion är att hjälpa elever att utveckla en djup förståelse för Tajweed och en vacker recitation. Jag talar svenska, engelska, arabiska och somaliska, vilket gör det möjligt att undervisa elever med olika språkbakgrunder. Varje elev får personlig uppmärksamhet och en anpassad studieplan.",
      credentials: [
        "Certifierad koranlärare",
        "5 års undervisningserfarenhet",
        "Specialiserad i Tajweed",
        "Talar svenska, engelska, arabiska & somaliska"
      ]
    },
    howItWorks: {
      title: "Hur det fungerar",
      subtitle: "Din resa till korrekt koranläsning i fyra enkla steg",
      steps: [
        { title: "Boka provlektion", description: "Kostnadsfri introduktion" },
        { title: "Nivåbedömning", description: "Vi kartlägger din nuvarande nivå" },
        { title: "Personlig studieplan", description: "Anpassad plan för dina mål" },
        { title: "Börja din resa", description: "Regelbundna lektioner startar" }
      ]
    },
    testimonials: {
      title: "Vad våra elever säger",
      subtitle: "Recensioner från nöjda elever",
      reviews: [
        {
          text: "Fantastisk lärare med mycket tålamod. Min Tajweed har förbättrats enormt på bara några månader.",
          name: "Ahmad K.",
          role: "Elev sedan 2023"
        },
        {
          text: "Strukturerad undervisning som verkligen fungerar. Rekommenderas starkt för alla som vill lära sig korrekt.",
          name: "Fatima M.",
          role: "Förälder"
        },
        {
          text: "Mina barn älskar lektionerna. Professionellt och engagerat bemötande varje gång.",
          name: "Omar S.",
          role: "Förälder till 3 elever"
        }
      ]
    },
    contact: {
      title: "Kontakta oss",
      subtitle: "Vi svarar på alla dina frågor",
      name: "Namn",
      email: "E-post",
      phone: "Telefon",
      message: "Meddelande",
      send: "Skicka meddelande",
      success: "Tack för ditt meddelande! Vi återkommer inom kort.",
      info: {
        email: "E-post",
        phone: "Telefon",
        whatsapp: "WhatsApp"
      }
    },
    footer: {
      tagline: "Professionell koranundervisning online",
      quickLinks: "Snabblänkar",
      contact: "Kontakt",
      rights: "Alla rättigheter förbehållna"
    },
    booking: {
      title: "Boka gratis provlektion",
      subtitle: "Fyll i formuläret så kontaktar vi dig inom 24 timmar",
      studentAge: "Elevens ålder",
      preferredTime: "Önskad tid",
      experience: "Tidigare erfarenhet",
      experienceOptions: [
        "Nybörjare - aldrig läst Koranen",
        "Kan läsa arabiska bokstäver",
        "Kan läsa Koranen men vill förbättra Tajweed",
        "Avancerad - vill perfektera recitation"
      ],
      submit: "Skicka bokningsförfrågan",
      success: "Tack! Vi kontaktar dig inom 24 timmar för att bekräfta din provlektion."
    },
    quran: {
      title: "Den Heliga Koranen",
      subtitle: "Läs och utforska alla 114 suror",
      tabs: { surah: "Surah", juz: "Juz", chronological: "Kronologisk ordning" },
      ayahs: "Ayah",
      meccan: "Mecka",
      medinan: "Medina",
      sortBy: "Sortera",
      searchPlaceholder: "Sök surah...",
      reading: "Läser",
      backToList: "Tillbaka",
      verse: "Vers",
      loading: "Laddar...",
      error: "Kunde inte ladda surah. Försök igen.",
      juzLabel: "Juz"
    }
  },
  en: {
    nav: {
      home: "Home",
      programs: "Programs",
      about: "About",
      quran: "Quran",
      materials: "Materials",
      contact: "Contact",
      book: "Book Lesson"
    },
    hero: {
      title: "Learn to Recite the Quran Correctly",
      titleHighlight: "with Personal Guidance Online",
      subtitle: "Structured 1-on-1 lessons, small group classes, and an exclusive membership platform.",
      cta: "Book Free Trial Lesson",
      ctaSecondary: "View Programs"
    },
    whyUs: {
      title: "Why Choose Us",
      subtitle: "We offer a professional and structured path to correct Quran recitation",
      features: [
        {
          title: "Certified and Experienced Teacher",
          description: "Qualified instruction with ijazah and many years of experience"
        },
        {
          title: "Personalized Development Plan",
          description: "Customized study plan based on your level and goals"
        },
        {
          title: "Focus on Tajweed",
          description: "Correct pronunciation and recitation according to traditional rules"
        },
        {
          title: "Structured Learning",
          description: "Disciplined and methodical teaching for best results"
        },
        {
          title: "For Children and Adults",
          description: "Adapted programs for all ages and levels"
        }
      ]
    },
    programs: {
      title: "Our Packages",
      subtitle: "Choose the package that suits you best. The more lessons, the better the price!",
      lessonInfo: "40 min per lesson | Max 2-3 students per class",
      categories: {
        nooraniyah: "Quran Online Method",
        tajweed: "Tajweed",
        family: "Family Package"
      },
      nooraniyah: {
        label: "Quran Online Method - Beginner Course",
        description: "Learn to read the Quran from scratch with correct pronunciation",
        basePrice: "125 SEK/lesson",
        packages: [
          {
            name: "Basic",
            lessons: "4 lessons/month",
            frequency: "1 lesson per week",
            price: "500",
            perLesson: "125 SEK/lesson",
            discount: null,
            features: ["Personal study plan", "Direct pronunciation correction", "Flexible schedule", "Online via Teams, Zoom or Google Meet"],
            cta: "Choose Basic",
            popular: false
          },
          {
            name: "Standard",
            lessons: "8 lessons/month",
            frequency: "2 lessons per week",
            price: "880",
            perLesson: "110 SEK/lesson",
            discount: "Save 12%",
            features: ["Everything in Basic", "Faster progress", "Priority booking", "Personal follow-up"],
            cta: "Choose Standard",
            popular: true
          },
          {
            name: "Premium",
            lessons: "12 lessons/month",
            frequency: "3 lessons per week",
            price: "1 200",
            perLesson: "100 SEK/lesson",
            discount: "Save 20%",
            features: ["Everything in Standard", "Best price per lesson", "Extra practice material", "Fastest results"],
            cta: "Choose Premium",
            popular: false
          }
        ]
      },
      tajweed: {
        label: "Tajweed - Advanced Course",
        description: "Refine your Quran recitation with advanced Tajweed rules",
        basePrice: "135 SEK/lesson",
        packages: [
          {
            name: "Basic",
            lessons: "4 lessons/month",
            frequency: "1 lesson per week",
            price: "540",
            perLesson: "135 SEK/lesson",
            discount: null,
            features: ["Advanced Tajweed instruction", "Articulation points", "Flexible schedule", "Online via Teams, Zoom or Google Meet"],
            cta: "Choose Basic",
            popular: false
          },
          {
            name: "Standard",
            lessons: "8 lessons/month",
            frequency: "2 lessons per week",
            price: "960",
            perLesson: "120 SEK/lesson",
            discount: "Save 11%",
            features: ["Everything in Basic", "Faster progress", "Priority booking", "Personal follow-up"],
            cta: "Choose Standard",
            popular: true
          },
          {
            name: "Premium",
            lessons: "12 lessons/month",
            frequency: "3 lessons per week",
            price: "1 300",
            perLesson: "108 SEK/lesson",
            discount: "Save 20%",
            features: ["Everything in Standard", "Best price per lesson", "Idghaam, Ikhfaa & Madd rules", "Fastest results"],
            cta: "Choose Premium",
            popular: false
          }
        ]
      },
      family: {
        label: "Family Package",
        description: "Discounted packages for families with multiple students",
        basePrice: "From 100 SEK/lesson",
        packages: [
          {
            name: "Family Duo",
            lessons: "8 lessons/month",
            frequency: "4 lessons per student/week (2 students)",
            price: "900",
            perLesson: "112 SEK/lesson",
            discount: "Save 10%",
            features: ["2 family members", "4 lessons per student/month", "Customized plan per student", "Flexible scheduling"],
            cta: "Choose Family Duo",
            popular: false
          },
          {
            name: "Family Standard",
            lessons: "16 lessons/month",
            frequency: "8 lessons per student (2 students)",
            price: "1 600",
            perLesson: "100 SEK/lesson",
            discount: "Save 20%",
            features: ["2 family members", "8 lessons per student/month", "Faster progress", "Personal follow-up"],
            cta: "Choose Family Standard",
            popular: true
          },
          {
            name: "Family Premium",
            lessons: "12+ lessons/month",
            frequency: "4 lessons per student (3+ students)",
            price: "1 200",
            perLesson: "100 SEK/lesson",
            discount: "Save 20%",
            features: ["3 or more family members", "4 lessons per student/month", "Best family price", "Shared family report"],
            cta: "Choose Family Premium",
            popular: false
          }
        ]
      }
    },
    about: {
      title: "About the Teacher",
      subtitle: "Dedicated Quran instruction with passion",
      bio: "With 5 years of experience in Quran education, I offer a structured and disciplined path to correct Quran recitation. My passion is helping students develop a deep understanding of Tajweed and beautiful recitation. I speak Swedish, English, Arabic and Somali, making it possible to teach students from diverse linguistic backgrounds. Every student receives personal attention and a customized study plan.",
      credentials: [
        "Certified Quran teacher",
        "5 years teaching experience",
        "Specialized in Tajweed",
        "Speaks Swedish, English, Arabic & Somali"
      ]
    },
    howItWorks: {
      title: "How It Works",
      subtitle: "Your journey to correct Quran recitation in four simple steps",
      steps: [
        { title: "Book Trial Lesson", description: "Free introduction session" },
        { title: "Level Assessment", description: "We evaluate your current level" },
        { title: "Personal Study Plan", description: "Customized plan for your goals" },
        { title: "Start Your Journey", description: "Regular lessons begin" }
      ]
    },
    testimonials: {
      title: "What Our Students Say",
      subtitle: "Reviews from satisfied students",
      reviews: [
        {
          text: "Amazing teacher with great patience. My Tajweed has improved tremendously in just a few months.",
          name: "Ahmad K.",
          role: "Student since 2023"
        },
        {
          text: "Structured teaching that really works. Highly recommended for anyone wanting to learn correctly.",
          name: "Fatima M.",
          role: "Parent"
        },
        {
          text: "My children love the lessons. Professional and engaging approach every time.",
          name: "Omar S.",
          role: "Parent of 3 students"
        }
      ]
    },
    contact: {
      title: "Contact Us",
      subtitle: "We answer all your questions",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send Message",
      success: "Thank you for your message! We will get back to you shortly.",
      info: {
        email: "Email",
        phone: "Phone",
        whatsapp: "WhatsApp"
      }
    },
    footer: {
      tagline: "Professional Quran education online",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved"
    },
    booking: {
      title: "Book Free Trial Lesson",
      subtitle: "Fill out the form and we will contact you within 24 hours",
      studentAge: "Student's age",
      preferredTime: "Preferred time",
      experience: "Previous experience",
      experienceOptions: [
        "Beginner - never read the Quran",
        "Can read Arabic letters",
        "Can read Quran but want to improve Tajweed",
        "Advanced - want to perfect recitation"
      ],
      submit: "Send Booking Request",
      success: "Thank you! We will contact you within 24 hours to confirm your trial lesson."
    },
    quran: {
      title: "The Holy Quran",
      subtitle: "Read and explore all 114 surahs",
      tabs: { surah: "Surah", juz: "Juz", chronological: "Chronological Order" },
      ayahs: "Ayahs",
      meccan: "Meccan",
      medinan: "Medinan",
      sortBy: "Sort",
      searchPlaceholder: "Search surah...",
      reading: "Reading",
      backToList: "Back",
      verse: "Verse",
      loading: "Loading...",
      error: "Could not load surah. Please try again.",
      juzLabel: "Juz"
    }
  }};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang];
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
